import React, { FC } from 'react';
import { Paper, PaperProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { Subtract } from 'utility-types';

interface ISubtracted {
  classes?: PaperProps['classes'];
}

interface IProps extends Subtract<PaperProps, ISubtracted> {
  padding?: number | string;
}

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}));

const PaddedPaper: FC<IProps> = ({ className, padding, children, ...rest }) => {
  const classes = useStyles();

  return (
    <Paper className={classNames(classes.root, className)} {...rest}>
      {children}
    </Paper>
  );
};

export default PaddedPaper;
